export const MetricCard = ({ label, value, delta, icon: Icon, accent = "blue", testid, onClick }) => {
  const accent_map = {
    blue:   { icon: "#3B82F6", bg: "rgba(59,130,246,0.1)",  border: "rgba(59,130,246,0.18)"  },
    emerald:{ icon: "#10B981", bg: "rgba(16,185,129,0.1)",  border: "rgba(16,185,129,0.18)"  },
    amber:  { icon: "#F59E0B", bg: "rgba(245,158,11,0.1)",  border: "rgba(245,158,11,0.18)"  },
    red:    { icon: "#EF4444", bg: "rgba(239,68,68,0.1)",   border: "rgba(239,68,68,0.18)"   },
  };
  const a = accent_map[accent] || accent_map.blue;

  return (
    <div
      data-testid={testid}
      className="rounded-2xl p-5 transition-all duration-200"
      style={{
        background: "rgba(255,255,255,0.03)",
        border: "1px solid rgba(255,255,255,0.08)",
        cursor: onClick ? "pointer" : "default",
      }}
      onClick={onClick}
      onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-2px)"; if (onClick) e.currentTarget.style.borderColor = "rgba(255,255,255,0.14)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; if (onClick) e.currentTarget.style.borderColor = "rgba(255,255,255,0.08)"; }}
    >
      <div className="flex items-start justify-between mb-4">
        <p
          className="text-[11px] font-semibold tracking-[0.08em] uppercase leading-tight"
          style={{ color: "rgba(255,255,255,0.4)" }}
        >
          {label}
        </p>
        {Icon && (
          <div
            className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
            style={{ background: a.bg, border: `1px solid ${a.border}` }}
          >
            <Icon className="w-4 h-4" style={{ color: a.icon }} />
          </div>
        )}
      </div>

      <p className="text-[36px] font-bold text-white leading-none tracking-tight">
        {value}
      </p>

      {delta && (
        <p
          className="text-[12px] mt-2 font-medium"
          style={{ color: "rgba(255,255,255,0.35)" }}
        >
          {delta}
        </p>
      )}
    </div>
  );
};
